class FetchService {
  constructor($http, $rootScope) {
    if ($http && $rootScope.globals)
      $http.defaults.headers.common["Authorization"] =
        "Bearer " + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getCareType() {
    return this.$http.get(
      "" + WEBSERVICEURL + "/dataagility/api/service.refcode/query?domain=CARE"
    );
  }
}

class CodedmedicalrecordsController {
  constructor(
    $http,
    $scope,
    DTOptionsBuilder,
    DTColumnBuilder,
    User,
    Constants,
    CONST,
    materialButtons,
    datePicker,
    $rootScope,
    $location,
    FunctionService,
    $timeout
  ) {
    $http.defaults.headers.common["Authorization"] =
      "Bearer " + $rootScope.globals.currentUser.token;
    this.datatableApi;
    this.user = User.getUser();
    this.name = "Coded Medical Records";
    this.episodeValue = "";
    this.specialtyString = "";
    this.totalUsers = 0;
    this.grandTotalCoded = 0;
    this.grandTotalWies = 0;
    this.locale = "en-au";

    this.dateTypeOptions = [
      { id: 0, value: "Coded Date" }
    ];
    this.dateType = this.dateTypeOptions[0];
    $scope.vm.selectedDateTypeId = this.dateType.id;

    this.url =
      WEBSERVICEURL + "/dataagility/api/service.medicalrecords/coded/?";
    this.initUrl =
      this.url +
      "dateType=" +
      $scope.vm.selectedDateTypeId +
      "&startDate=" +
      moment().locale(this.locale).subtract(1, "days").format("L") +
      "&endDate=" +
      moment().locale(this.locale).subtract(1, "days").format("L");

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.episodeValue =
          response.functionSettings.EpisodeValue.valueString;
        $scope.vm.separationString =
          response.functionSettings.SeparationString.valueString;
        $scope.vm.functionSettings = response.functionSettings;


        const option = { id: 1, value: $scope.vm.separationString + " Date" };
        $scope.vm.dateTypeOptions.push(option);

        // All Private Clients should be active, All Public should be inactive
        if ($scope.vm.episodeValue === '$') {
          console.log('WIES vars set to private');
          $scope.vm.wiesDefault = "0.00";
          $scope.vm.wiesParseAmount = 2;
        } else {
          console.log('WIES vars set to public');
          $scope.vm.wiesDefault = "0.0000";
          $scope.vm.wiesParseAmount = 4;
        }

        Constants.campusData().then(function successCallback(response) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.functionSettings.LimitCampusDropDown &&
            $scope.vm.functionSettings.LimitCampusDropDown.isActive
          ) {
            let campusOptions = [];
            if (typeof $scope.vm.user.campus === "string") {
              campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
            } else {
              campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
            }
            $scope.vm.campusOptions = campusOptions;
            $scope.vm.campus.selectedCampus = campusOptions;
          } else {
            $scope.vm.campusOptions = response;
          }
        });

        $scope.vm.specialtyString =
          response.functionSettings.SpecialtyString.valueString;
      }
    );

    materialButtons.render();

    materialButtons.processing();

    jQuery.fn.dataTable.Api.register("sum()", function () {
      return this.flatten().reduce(function (a, b) {
        if (typeof a === "string") {
          a = a.replace(/[^\d.-]/g, "") * 1;
        }
        if (typeof b === "string") {
          b = b.replace(/[^\d.-]/g, "") * 1;
        }

        return a + b;
      }, 0);
    });

    $scope.drawCallback = function (nRow, aData, index) {
      $scope.vm.totalUsers = this.api().column(0).data().count();
      $scope.vm.grandTotalCoded = this.api().column(1).data().sum();
      $scope.vm.grandTotalWies = this.api().column(2).data().sum().toFixed($scope.vm.wiesParseAmount);
    };

    $scope.initCallback = function (
      nRow,
      aData,
      iDisplayIndex,
      iDisplayIndexFull
    ) {
      // Datatables has finished init
      // Initialise searching
      if ($scope.vm.datatableApi) return;

      $scope.vm.datatableApi = this.api();

      // Update column headers even when no data returned
      setDtHeaders($scope.vm.datatableApi);

      // setup search filters
      search();

      // set the table to a fixed height, so it never collapsed up and down
      $("#auditTable").closest(".dataTables_scrollBody").height(300);
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption("ajax", {
        headers: {
          Authorization: "Bearer " + $rootScope.globals.currentUser.token,
        },
        url: $scope.vm.initUrl,
        type: "GET",
        error: (xhr, error, thrown) => {
          if (thrown == "Unauthorized") {
            //window.location.replace(window.location.origin + '/login');
            console.log(
              "Unauthorized request with token: ",
              $rootScope.globals.currentUser.token
            );
          }
        },
      })
      .withDisplayLength(CONST.TABLEROWS)
      .withDataProp("data")
      .withOption("processing", true)
      .withOption("sAjaxDataProp", "")
      .withOption("bLengthChange", false)
      .withPaginationType("simple_numbers")
      .withOption("rowCallback", function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($("#auditTable").DataTable());
      })
      .withOption("drawCallback", $scope.drawCallback)
      .withOption("initComplete", $scope.initCallback)
      .withOption("scrollY", "300px")
      .withOption("scrollX", "auto")
      .withOption("aaSorting", [[0, "asc"]])
      .withOption("dom", '<"wrapper"rt<"table-footer"iBp>>')
      .withButtons([
        {
          extend: "print",
          text: "",
        },
        {
          extend: "csvHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          extend: "excelHtml5",
          text: "",
          filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm"),
        },
        {
          text: "",
          action: function (e, dt, node, config) {
            dt.ajax.reload();
          },
        },
      ])

      .withColumnFilter({
        //sPlaceHolder: "head:after",
        aoColumns: [
          { type: "select" },
          { type: "number" },
          { type: "number" },
          { type: "number" },
        ],
      });

    this.dtColumns = [
      DTColumnBuilder.newColumn("PCCLModifiedUser")
        .withTitle("User")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalCoded")
        .withTitle("Total Coded")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric"),
      DTColumnBuilder.newColumn("totalWies")
        .withTitle("Loading...")
        .withOption("defaultContent", $scope.vm.wiesDefault)
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
        }),
      DTColumnBuilder.newColumn("avgWies")
        .withTitle("Loading...")
        .withOption("defaultContent", $scope.vm.wiesDefault)
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
        }),
      DTColumnBuilder.newColumn("avgLOS")
        .withTitle("Average LOS")
        .withOption("defaultContent", "0")
        .withClass("mdl-data-table__cell--non-numeric")
        .renderWith(function (data, type, full) {
          return parseFloat(data).toFixed($scope.vm.wiesParseAmount);
        }),

    ];

    function setDtHeaders(table) {
      $(table.column(getIndexOfColumn('totalWies')).header()).html("Total " + $scope.vm.episodeValue);
      $(table.column(getIndexOfColumn('avgWies')).header()).html("Average " + $scope.vm.episodeValue);
    }

    function getIndexOfColumn(columnName) {
      const selectedColumn = $scope.vm.dtColumns.filter(x => x.mData === columnName);
      return $scope.vm.dtColumns.indexOf(selectedColumn[0]);
    }

    // Search filters
    this.caretypeOptions = [];
    this.caretype = {
      selectedCaretype: [],
    };
    this.allCareTypeOptions = [];

    this.specialty = {
      selectedSpecialty: [],
    };
    this.specialtyOptions = {};

    this.los = {
      selectedLos: [],
    };
    this.losOptions = {};

    Constants.getDivisionAndSpecialtyData().then(function (response) {
      $scope.vm.specialtyOptions = response.specialties;
      filterSpecialty(response.specialties);
      // Can load divisions if needed??
    });

    this.startDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    this.endDatePicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    this.dischargeDateFromPicker = {
      input: {
        date: moment()
          .locale(this.locale)
          .subtract(60, "days")
          .startOf("month"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(60, "days")
          .startOf("month")
          .format("L"),
      },
    };

    this.dischargeDateEndPicker = {
      input: {
        date: moment().locale(this.locale).subtract(1, "days"),
        dateFormatted: moment()
          .locale(this.locale)
          .subtract(1, "days")
          .format("L"),
      },
    };

    datePicker.autoClose($scope);

    // callbacks for lx-selects and lx-date-picker
    // TODO sort out specialtyCallback/selectCallback
    this.specialtyCallback = specialtyCallback;
    this.selectCallback = selectCallback;
    this.filterCaretype = filterCaretype;
    datePicker.autoClose($scope);


    function specialtyCallback(_newValue, _oldValue) {
      $scope.vm.changeData();
    }

    function filterSpecialty(swap) {
      $scope.vm.specialty.selectedSpecialty = [];
      if (swap === "add") {
        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
      }
    }

    function filterCampus(modifier) {
      $scope.vm.campus.selectedCampus = [];
      if (modifier === "add") {
        $scope.vm.campus.selectedCampus = $scope.vm.campusOptions;
      }
    }

    function filterLos(swap) {
      $scope.vm.losOptions = CONST.LOSSIMPLE;
      $scope.vm.los.selectedLos = [];

      if (swap !== "minus") {
        angular.forEach(CONST.LOSSIMPLE, function (value, key) {
          $scope.vm.los.selectedLos.push(
            $scope.vm.losOptions[$scope.vm.losOptions.indexOf(value)]
          );
        });
      }
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return "";
      }
    }

    function checkParamCare(param) {
      let codes = [];

      if (param.length !== 0) {
        angular.forEach(param, function (value, key) {
          codes.push(value.code);
        });

        return encodeURIComponent(codes.join());
      } else {
        return "";
      }
    }

    this.changeData = changeData;

    function changeData() {
      if ($scope.vm.datatableApi) {
        var campus = "";
        if (
          $scope.vm.functionSettings.LimitCampusDropDown &&
          $scope.vm.functionSettings.LimitCampusDropDown.isActive
        ) {
          if (
            $scope.vm.user.role !== "Administrator" &&
            $scope.vm.campus.selectedCampus.length === 0
          ) {
            campus = $scope.vm.user.campus;
          } else {
            campus = $scope.vm.campus.selectedCampus;
          }
        } else {
          campus = $scope.vm.campus.selectedCampus;
        }

        var newUrl =
          $scope.vm.url +
          "dateType=" +
          $scope.vm.selectedDateTypeId +
          "&startDate=" +
          $scope.vm.startDatePicker.input.dateFormatted +
          "&endDate=" +
          $scope.vm.endDatePicker.input.dateFormatted +
          "&careType=" +
          checkParamCare($scope.vm.caretype.selectedCaretype) +
          "&specialty=" +
          checkParam($scope.vm.specialty.selectedSpecialty) +
          "&campus=" +
          checkParam(campus) +
          "&los=" +
          encodeURIComponent($scope.vm.los.selectedLos);
        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
      }
    }

    function search() {
      // delete any global searches previously applied
      if ($.fn.dataTable.ext.search.length === 1)
        $.fn.dataTable.ext.search.shift();

      var auditTable = $scope.vm.datatableApi;
      auditTable.search("").draw();

      filterSpecialty("minus");
      filterLos("minus");

      // re-draw table on datepicker close
      $scope.$on("lx-date-picker__close-start", function (e, id) {
        $scope.vm.changeData();
      });
    }

    $scope.getCareType = function () {
      new FetchService($http, $scope).getCareType().then(
        function successCallback(response) {
          angular.forEach(response.data, function (value, key) {
            $scope.vm.caretypeOptions.push(value);
          });
        },
        function errorCallback(response) {
          // $scope.feedback = "Error loading data";
          if (response.status === 401) {
            window.location.replace(
              window.location.origin + "/login?logout=true"
            );
          }
        }
      );
    };

    this.setDateType = setDateType;

    function setDateType(newValue) {
      $scope.vm.dateType = newValue;
      $scope.vm.selectedDateTypeId = newValue.id;
      $scope.vm.selectedDateTypeValue = newValue.value;
      $scope.vm.changeData();
    }

    $scope.getCareType();

    function selectCallback(_newValue, _oldValue) {
      //$scope.reload();
      $scope.vm.changeData();
    }

    function filterCaretype(swap) {
      $scope.vm.caretype.selectedCaretype = [];

      if (swap !== "minus") {
        angular.forEach($scope.vm.caretypeOptions, function (value, key) {
          $scope.vm.caretype.selectedCaretype.push(value);
        });
      }
    }

    // bind filter swap
    this.filterSwap = filterSwap;

    function filterSwap(thisFilter, thisModifier) {
      switch (thisFilter) {
        case "specialty":
          if (thisModifier === "add") {
            filterSpecialty("add");
          } else {
            filterSpecialty("minus");
          }
          break;

        case "los":
          if (thisModifier === "add") {
            filterLos("add");
          } else {
            filterLos("minus");
          }
          break;

        case "campus":
          if (thisModifier === "add") {
            filterCampus("add");
          } else {
            filterCampus("minus");
          }
          break;

        case "startDate":
          $scope.vm.startDatePicker.input.date = null;
          $scope.vm.startDatePicker.input.dateFormatted = null;
          break;

        case "endDate":
          $scope.vm.endDatePicker.input.date = null;
          $scope.vm.endDatePicker.input.dateFormatted = null;
          break;

        case "dischargeDateFrom":
          $scope.vm.dischargeDateFromPicker.input.date = null;
          $scope.vm.dischargeDateFromPicker.input.dateFormatted = null;
          break;

        case "dischargeDateEnd":
          $scope.vm.dischargeDateEndPicker.input.date = null;
          $scope.vm.dischargeDateEndPicker.input.dateFormatted = null;
          break;
        default:
          break;
      }
    }

    // bind the datatable instance to an object to monitor loading
    this.dtInstanceCallback = dtInstanceCallback;

    function dtInstanceCallback(dtInstance) {
      $scope.dtInstance = dtInstance._renderer;
    }

    // Force bindings for totals to update once datatable is drawn after page load/refresh
    $("#auditTable").on("draw.dt", function () {
      if ($scope.vm.datatableApi) {
        $timeout(function () {
          // anything you want can go here and will safely be run on the next digest.
          $scope.$apply();
        });
      }
    });
  }
}

export default CodedmedicalrecordsController;



// WEBPACK FOOTER //
// ./client/app/common/reports/codedmedicalrecords/codedmedicalrecords.controller.js